import z from "zod";

import { mapErrorsToFields } from "../../../../utils";
import CharityIssueCharityService from "../../../../services/CharityIssueCharityService";

const api = new CharityIssueCharityService();
export type State = {
  message: string | null;
  errors?: {
    incidence?: string[];
    general?: string[];
  };
  success: boolean;
  defaultValues: {
    incidence?: number;
  };
};

const FormSchema = z.object({
  incidence: z.number().min(0, { message: "Incidence must be a positive number." }),
  charityId: z.number(),
  charityIssueId: z.number(),
});

export async function createCharityIssueCharity(
  prevState: State,
  formData: FormData
): Promise<State> {
  const defaultValues = {
    incidence: parseFloat(formData.get("incidence")?.toString() || "0"),
    charityId: parseInt(formData.get("charityId")?.toString() || "0"),
    charityIssueId: parseInt(formData.get("charityIssueId")?.toString() || "0"),
  };
  try {
    const validatedFields = FormSchema.safeParse(defaultValues);
    if (!validatedFields.success) {
      return {
        errors: mapErrorsToFields(validatedFields.error),
        message: "Failed to create charity issue charity.",
        defaultValues,
        success: false,
      };
    }
    const result = await api.createCharityIssueCharity(validatedFields.data);
    if (result.status === 201)
      return {
        errors: {},
        message: "Charity Issue Charity created successfully.",
        defaultValues,
        success: true,
      };
    else if (result.status === 400)
      return {
        errors: {},
        message: result.data.description,
        defaultValues,
        success: false,
      };
  } catch (error) {
    console.error("Error creating charity issue charity:", error);
  }
  return {
    errors: {},
    message: "Failed to create charity issue charity.",
    defaultValues,
    success: false,
  };
}

export async function updateCharityIssueCharity(
  id: number,
  prevState: State,
  formData: FormData
): Promise<State> {
  const defaultValues = {
    incidence: parseFloat(formData.get("incidence")?.toString() || "0"),
    charityId: parseInt(formData.get("charityId")?.toString() || "0"),
    charityIssueId: parseInt(formData.get("charityIssueId")?.toString() || "0"),
  };
  try {
    const validatedFields = FormSchema.safeParse(defaultValues);
    if (!validatedFields.success) {
      return {
        errors: mapErrorsToFields(validatedFields.error),
        message: "Failed to update charity issue charity.",
        defaultValues,
        success: false,
      };
    }
    const result = await api.updateCharityIssueCharity(id, {
      id: id,
      ...validatedFields.data,
    });
    if (result.status === 204)
      return {
        errors: {},
        message: "Charity Issue updated successfully.",
        defaultValues,
        success: true,
      };
  } catch (error) {
    console.error("Error updating charity issue charity:", error);
  }
  return {
    errors: {},
    message: "Failed to update charity issue charity.",
    defaultValues,
    success: false,
  };
}

export async function deleteCharityIssueCharity(
  id: number
): Promise<{ success: boolean }> {
  try {
    const result = await api.deleteCharityIssueCharity(id);
    return { success: result.status === 204 };
  } catch (error) {
    console.error("Database Error:", error);
  }
  return { success: false };
}
